// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:58:39

export default {
  "id": "gt-championship-arcade",
  "slug": "gt-championship-arcade",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/f91602ea0cae446386b1db3be3200c5e-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/f91602ea0cae446386b1db3be3200c5e/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "GT Championship Arcade",
      "description": "Get ready to ignite your engines and experience the ultimate rush of speed in GT Championship Arcade! This fast-paced, adrenaline-fueled racing game brings the excitement of GT racing into a visually stunning, arcade-style world filled with neon-lit tracks, intense rivalries, and heart-pounding action. Whether you’re a casual gamer looking for quick thrills or a hardcore racing fan seeking the ultimate challenge, this game offers an electrifying experience like no other.",
      "instructions": "Arrow key/WASD to move\nEsc - pause menu",
      "genres": [
        "Racing & Driving",
        "Simulation"
      ],
      "tags": [
        "1player",
        "car",
        "drag",
        "track"
      ]
    },
    "zh-CN": {
      "title": "GT锦标赛街机",
      "description": "准备好点燃你的引擎，在GT锦标赛街机游戏中体验速度的极致快感！这款节奏飞快的肾上腺素激增赛车游戏，将GT赛车的激情带入一个视觉上令人惊叹的街机风格世界，这里有霓虹灯照亮的赛道、激烈的竞争和心跳加速的刺激。无论是寻求快速刺激的休闲玩家，还是寻求终极挑战的硬核赛车粉丝，这款游戏提供了一种前所未有的电光火石般的体验。",
      "instructions": "方向键/WASD 移动\nEsc - 暂停菜单",
      "genres": [
        "赛车与驾驶",
        "模拟"
      ],
      "tags": [
        "1玩家",
        "赛车",
        "竞速",
        "赛道"
      ]
    },
    "zh-TW": {
      "title": "GT冠軍賽道電玩",
      "description": "準備發動引擎，體驗GT冠軍賽車遊戲中的極速衝刺！這款節奏緊湊、充滿肾上腺素的速度競速遊戲，將GT賽車的熱鬧帶入一個視覺效果震撼的電玩風格世界，裡頭充滿霓虹燈的賽道、激烈的競爭對手和心臟噗通噗通的動作。無論你是尋求快速刺激的休闲玩家，或是尋求最終挑戰的硬核競速迷，這款遊戲都能提供其他遊戲無法比擬的驚險體驗。",
      "instructions": "箭頭鍵/WASD 移動\nEsc - 暫停選單",
      "genres": [
        "賽車與駕駛",
        "模擬"
      ],
      "tags": [
        "1 玩家",
        "車輛",
        "競速",
        "賽道"
      ]
    },
    "zh-HK": {
      "title": "GT冠軍賽道體驗",
      "description": "準備燃點引擎，體驗GT冠軍賽車場的無敵速度衝擊！這款節奏快速的冒險賽車遊戲，將GT賽車的熱鬧氣氛帶入一個視覺驚艷的電子遊戲世界，充滿霓虹燈照耀的賽道、激烈的競爭對手和心臟跳動的動作。無論你是尋找刺激的休闲玩家，還是尋求最終挑戰的硬核賽車迷，這款遊戲都提供一種前所未有的驚電般體驗。",
      "instructions": "方向鍵 / WASD 移動\nEsc - 暂停選單",
      "genres": [
        "賽車及駕駛",
        "模擬"
      ],
      "tags": [
        "1人玩家",
        "車輛",
        "拖地",
        "軌道"
      ]
    },
    "ja": {
      "title": "GTチャンピオンシップアーケード",
      "description": "エンジンを熱上げて、GTチャンピオンシップアーケードの究極のスピードの疾走を体験しよう！このスピーディでアドレナリンに満ちたレースゲームは、ネオンで照らされたトラック、熾烈なライバル関係、心臓がドキドキするアクションが満載の視覚的に美しいアーケードの世界にGTレースの興奮をもたらします。カジュアルなゲーマーであれ、究極の挑戦を求めるハードコアのレースファンであれ、このゲームは他に類を見ない電気のような体験を提供します。",
      "instructions": "矢印キー/WASDで移動\nEsc - ペーストメニュー",
      "genres": [
        "レーシング & ドライビング",
        "シミュレーション"
      ],
      "tags": [
        "1プレイヤー",
        "車",
        "ドライブ",
        "トラック"
      ]
    },
    "ko": {
      "title": "GT 챔피언십 아케이드",
      "description": "엔진을 켜고 GT 챔피언십 아케이드에서 최고의 속도의 열기를 경험해보세요! 이 빠른 템포와 앙련된 어드레날린이 가득한 레이싱 게임은GT 레이싱의 흥분을霓虹이 밝은 트랙, 치열한 라이벌들, 심장을 뛰게 만드는 액션으로 풍부한 아케이드 스타일의 세계로 가져옵니다. 쉽게 즐길 수 있는 게이머든 최고의 도전을 찾는 열성적인 레이싱 팬이든, 이 게임은 다른 어떤 게임보다 전기적인 경험을 제공합니다.",
      "instructions": "아로우 키 / WASD로 이동\nEsc - 일시 중지 메뉴",
      "genres": [
        "레이싱 & 드라이빙",
        "시뮬레이션"
      ],
      "tags": [
        "1플레이어",
        "자동차",
        "드래그",
        "트랙"
      ]
    },
    "fr": {
      "title": "Championnat GT Arcade",
      "description": "Préparez-vous à allumer vos moteurs et à vivre l'ultime frisson de la vitesse dans le GT Championship Arcade ! Ce jeu de course rapide et haletant apporte l'excitation des courses GT dans un monde visuellement époustouflant et aux styles d'arcade, illuminé de neon, avec des rivalités intenses et une action haletante. Que vous soyez un joueur occasionnel à la recherche de petites frayeurs ou un fan de courses à la recherche du défi ultime, ce jeu offre une expérience électrisante comme aucune autre.",
      "instructions": "Flèche clavier/WASD pour se déplacer\nEchap - menu de pause",
      "genres": [
        "Course et conduite",
        "simulation"
      ],
      "tags": [
        "1 joueur",
        "voiture",
        "glisser",
        "piste"
      ]
    }
  }
};
